import Cookies from 'js-cookie';

// TODO: Remove me, when Monolith is removed an services are RFC 6265 compliant
const MonolithCompatibleCookies = Cookies.withConverter({
    read(value) {
        return decodeURIComponent(value);
    },
    write(value) {
        return encodeURIComponent(value);
    }
});

function get(name, options) {
    return MonolithCompatibleCookies.get(name, options);
}

function set(name, value, options) {
    return MonolithCompatibleCookies.set(name, value, options);
}

function remove(name, options) {
    return MonolithCompatibleCookies.remove(name, options);
}

function update(name, newValue) {
    remove(name);
    return set(name, newValue);
}

export default {
    get,
    set,
    remove,
    update
};
